import { BrowserModule }                    from '@angular/platform-browser';
import { RouterModule }                     from '@angular/router';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule}                         from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http }                 from '@angular/http';
import { BrowserAnimationsModule }          from '@angular/platform-browser/animations';
import {MdButtonModule, MdMenuModule }       from '@angular/material';
import { MdExpansionModule}                 from '@angular/material';


import { MaterialModule }                   from '@angular/material';
import { ChartsModule }                     from 'ng2-charts';
import { CalendarModule }                   from 'angular-calendar';
import { NgxDatatableModule }               from '@swimlane/ngx-datatable';
import { AgmCoreModule }                    from '@agm/core';
import { SqueezeBoxModule }                 from 'squeezebox';

import { AppRoutingModule }                 from './app-routing.module';

import { AppComponent }                     from './app.component';

// A2 Components
import { NavbarComponent }                  from './home/pages/Dashboard/menus/top-navbar/top-navbar.component';
import { SidebarComponent }                 from './home/common-components/sidebar/sidebar.component';
import { LogoComponent }                    from './home/pages/Dashboard/logo/logo.component';
import { MainMenuComponent }                from './home/pages/Dashboard/menus/main-menu/main-menu.component';
import { A2CardComponent }                  from './home/common-components/card/card.component';
import { AlertComponent }                   from './home/common-components/alert/alert.component';
import { BadgeComponent }                   from './home/common-components/badge/badge.component';
import { BreadcrumbComponent }              from './home/common-components/breadcrumb/breadcrumb.component';
import { FileComponent }                    from './home/common-components/file/file.component';
import { NIHTimelineComponent }             from './home/common-components/ni-h-timeline/ni-h-timeline.component';
import { AngularFontAwesomeModule }         from 'angular-font-awesome';
import {NgxPaginationModule}                from 'ngx-pagination';

// Extra pages
import { FooterComponent }                  from './home/pages/Dashboard/footer/footer.component';
import { AdditionNavbarComponent }          from './home/common-components/addition-navbar/addition-navbar.component';
import { SignInComponent } from './home/pages/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './home/pages/forgot-password/forgot-password.component';
import { DashboardComponent } from './home/pages/Dashboard/dashboard.component';
import { SharedService} from './core/services/shared-service/shared.service';
import { ReportOverviewComponent } from './home/pages/Dashboard/AdminDashboardPages/report-overview/report-overview.component';
import { MailSentComponent } from './home/pages/mail-sent/mail-sent.component';
import { SideMenuComponent } from './home/pages/Dashboard/menus/main-menu/sidebar/menu-item-list.component';
import { MenuItemsComponent } from './home/pages/Dashboard/menus/main-menu/sidebar/menu-items/menu-items-setup.component';
import { ServiceManagementComponent } from './home/pages/Dashboard/AdminDashboardPages/service-management/service-management.component';
import { SystemActivityComponent } from './home/pages/Dashboard/AdminDashboardPages/system-activity/system-activity.component';
import { CreateUserComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/create-user/create-user.component';
import {
  DialogResultComponent,
  FreezeAccountComponent,
  ManageUsersComponent
} from './home/pages/Dashboard/AdminDashboardPages/User management/manage-agents/manage-users.component';
import { ManageCustomersComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/manage-customers/manage-customers.component';
import { CreateRoleComponent } from './home/pages/Dashboard/AdminDashboardPages/Role management/create-role/create-role.component';
import { ManageRoleComponent } from './home/pages/Dashboard/AdminDashboardPages/Role management/manage-role/manage-role.component';
import { GeneralSettingsComponent } from './home/pages/Dashboard/AdminDashboardPages/System settings/general-settings/general-settings.component';
import { EmailContactComponent } from './home/pages/Dashboard/AdminDashboardPages/System settings/email-contact/email-contact.component';
import { SmtpComponent } from './home/pages/Dashboard/AdminDashboardPages/System settings/smtp/smtp.component';
import { SocialMediaComponent } from './home/pages/Dashboard/AdminDashboardPages/System settings/social-media/social-media.component';
import { PaymentComponent } from './home/pages/Dashboard/AdminDashboardPages/System settings/payment/payment.component';
import {AuthService} from './core/authentication/auth-service.service';
import { CreateAdminComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/create-admin/create-admin.component';
import { NewPasswordComponent } from './home/pages/new-password/new-password.component';
import {AnonymousService} from './core/services/anonymous-service';
import { EditRoleComponent } from './home/pages/Dashboard/AdminDashboardPages/Role management/edit-role/edit-role.component';
import {UserService} from './core/services/users-service/user-service';
import { AdminProfileComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/admin-profile/admin-profile.component';
import {AdminChangePasswordComponent} from './home/pages/Dashboard/AdminDashboardPages/User management/admin-change-password/admin-change-password.component';
import { UserProfileComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/user-page/user-profile.component';

import { CustomAlertComponent } from './shared/components/custom-alert/custom-alert.component';
import {ErrorService} from './core/services/error_service/error.service';
import {EmailValidator} from 'ng2-validation/dist/email';
import {SortingService} from './shared/services/sort-service/sorting.service';
import {
  AgentDialogComponent,
  AgentAccountComponent
} from './home/pages/Dashboard/AdminDashboardPages/User management/user-page/agent-account/agent-account.component';
import { UserAgentsComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/user-page/user-agents/user-agents.component';
import { MatchPasswordDirective } from './shared/directives/match-password-directive/match-password.directive';
import { ManageAdminComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/manage-admin/manage-admin.component';
import { PermissionsComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/user-page/permissions/permissions.component';
import { ToastService} from './shared/services/toast-service/toast.service';
import { ToastrModule } from 'ngx-toastr';
import { QuickFundingComponent } from './home/pages/Dashboard/AdminDashboardPages/funding/quick-funding/quick-funding.component';
import {
  ApproveFunding, DeclineFunding,
  FundRequestsComponent, ViewProofOfPayment
} from './home/pages/Dashboard/AdminDashboardPages/funding/fund-requests/fund-requests.component';
import { FundHistoryComponent } from './home/pages/Dashboard/AdminDashboardPages/funding/fund-history/fund-history.component';
import {
  AirtimeComponent,
  ReportDialogComponent, TransactionDialogComponent
} from './home/pages/Dashboard/AdminDashboardPages/Transactions/airtime/airtime.component';
import {
  WalletComponent ,
  WalletReportDialogComponent
} from './home/pages/Dashboard/AdminDashboardPages/transactions/wallet/wallet.component';

//pipes
import { FilterPipe } from './shared/pipes/filter/filter.pipe';
import { MoneyFormatterPipe } from './shared/pipes/money-formatter/money-formatter.pipe';
import { MainMenuService} from './home/pages/Dashboard/menus/main-menu/main-menu.service';
import { MainMenu} from './home/pages/Dashboard/menus/main-menu/mock-main-menu-items';
import { Page500Component } from './home/pages/error-pages/page-500/page-500.component';
import { Page404Component } from './home/pages/error-pages/page-404/page-404.component';
import { AuthGuard } from './core/guards/auth-guard/auth.guard';
import { TransactionsPipe } from './shared/pipes/transactions-filter/airtime-transactions.pipe';
import { TransactionStatusFilterPipe } from './shared/pipes/transactions-status-filter/transaction-status-filter.pipe';
import { FundRequestFilterPipe } from './shared/pipes/fund-request-filter/fund-request-filter.pipe';
import { WalletTransactionsPipe } from './shared/pipes/transactions-filter/wallet-transactions.pipe';
import {
  FundAgentsComponent,
  fundDialogComponent
} from './home/pages/Dashboard/AdminDashboardPages/funding/fund-agents/fund-agents.component';
import { UserStatusFilterPipe } from './shared/pipes/user-status-filter/user-status-filter.pipe';
import {
  detailsDialogComponent,
  FrozenAccountsComponent
} from './home/pages/Dashboard/AdminDashboardPages/frozen-accounts/frozen-accounts.component';
import { CustomerProfileComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/user-page/customer-account/customer-account.component';
import { AdminAccountComponent } from './home/pages/Dashboard/AdminDashboardPages/User management/user-page/admin-account/admin-account.component';
import {
  NetworkDialogComponent,
  NetworksConfigurationComponent
} from './home/pages/Dashboard/AdminDashboardPages/networks-configuration/networks-configuration.component';
import { FundRequestHistoryFilterPipe } from './shared/pipes/fund-request-history/fund-request-history-filter.pipe';

import { LandingPageComponent } from './home/pages/landing-page/landing-page.component';
import { HomeComponent } from './home/pages/landing-page/home/home.component';
import { LandingPageNavbarComponent } from './home/pages/landing-page/common/landing-page-navbar/landing-page-navbar.component';
import { Logo2Component } from './home/common-components/logo-2/logo-2.component';
import { AgentSignUpComponent } from './home/pages/agent-sign-up/agent-sign-up.component';
import { AgentDashboardComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-dashboard/agent-dashboard.component';
import {StorageService} from './core/services/storage-service/storage.service';
import { CustomerSignUpComponent } from './home/pages/customer-sign-up/customer-sign-up.component';
import { AgentSellComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-sell/agent-sell.component';
import {
  AgentReportDialogComponent,
  AgentTransactionHistoryComponent
} from './home/pages/Dashboard/AgentDashboardPages/agent-transaction-history/agent-transaction-history.component';
import { SellAirtimeComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-sell/sell-airtime/sell-airtime.component';
import { SelectPackageComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-sell/select-package/select-package.component';
import { SellDataComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-sell/sell-data/sell-data.component';
import { AgentNewFundRequestComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-new-fund-request/agent-new-fund-request.component';
import { AgentFundRequestHistoryComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-fund-request-history/agent-fund-request-history.component';
import { AgentSupportComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-support/agent-support.component';
import { LandingPageFooterComponent } from './home/pages/landing-page/common/landing-page-footer/landing-page-footer.component';
import { CustomerDashboardComponent } from './home/pages/Dashboard/CustomerDashboardPages/customer-dashboard/customer-dashboard.component';
import { CustomerHomeComponent } from './home/pages/Dashboard/CustomerDashboardPages/customer-home/customer-home.component';
import { CustomerSettingsComponent } from './home/pages/Dashboard/CustomerDashboardPages/customer-settings/customer-settings.component';
import { CustomerTransactionHistoryComponent } from './home/pages/Dashboard/CustomerDashboardPages/customer-transaction-history/customer-transaction-history.component';
import { CommissionAccountsComponent } from './home/pages/Dashboard/AdminDashboardPages/audit/commission-accounts/commission-accounts.component';
import { PayoutRequestsComponent } from './home/pages/Dashboard/AdminDashboardPages/payout-requests/payout-requests.component';
import { CheckNullPipe } from './shared/pipes/check-null.pipe';
import { BuyAirtimeComponent } from './home/pages/Dashboard/CustomerDashboardPages/customer-dashboard/buy-airtime/buy-airtime.component';
import { BuyDataComponent } from './home/pages/Dashboard/CustomerDashboardPages/customer-dashboard/buy-data/buy-data.component';
import { PaymentStatusComponent } from './home/common-components/payment-status/payment-status.component';
import { AgentWalletComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-wallet/agent-wallet.component';
import { GuestAirtimeComponent } from './home/pages/landing-page/home/guest-airtime/guest-airtime.component';
import {AgentGuard} from './core/guards/agent-auth-guard/agent.guard';
import {AdminGuard} from './core/guards/admin-auth-guard/admin.guard';
import { GuestDataComponent } from './home/pages/landing-page/home/guest-data/guest-data.component';
import {AgentProfileComponent} from './home/pages/Dashboard/AgentDashboardPages/agent-profile/agent-profile.component';
import { AgentDataHistoryComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-data-history/agent-data-history.component';
import { AgentChangePasswordComponent } from './home/pages/Dashboard/AgentDashboardPages/agent-change-password/agent-change-password.component';
import {
  AgentWalletReportDialogComponent,
  AgentWalletTransactionHistoryComponent
} from './home/pages/Dashboard/AgentDashboardPages/agent-wallet-transaction-history/agent-wallet-transaction-history.component';

@NgModule({
  imports: [
    ToastrModule.forRoot(),
    BrowserModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    MaterialModule,
    MdButtonModule,
    MdMenuModule,
    MdExpansionModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpModule,
    ChartsModule,
    CalendarModule.forRoot(),
    NgxDatatableModule,
    AngularFontAwesomeModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAU9f7luK3J31nurL-Io3taRKF7w9BItQE'
    }),
    SqueezeBoxModule
  ],
  declarations : [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    AdminChangePasswordComponent,
    LogoComponent,
    MainMenuComponent,
    A2CardComponent,
    AlertComponent,
    BadgeComponent,
    BreadcrumbComponent,
    FileComponent,
    NIHTimelineComponent,

    FooterComponent,
    AdditionNavbarComponent,
    SignInComponent,
    ForgotPasswordComponent,
    DashboardComponent,
    ReportOverviewComponent,
    MailSentComponent,
    SideMenuComponent,
    MenuItemsComponent,
    ServiceManagementComponent,
    SystemActivityComponent,
    CreateUserComponent,
    ManageUsersComponent,
    ManageCustomersComponent,
    CreateRoleComponent,
    ManageRoleComponent,
    GeneralSettingsComponent,
    EmailContactComponent,
    EmailValidator,
    SmtpComponent,
    SocialMediaComponent,
    DialogResultComponent,
    FreezeAccountComponent,
    fundDialogComponent,
    PaymentComponent,
    CreateAdminComponent,
    NewPasswordComponent,
    EditRoleComponent,
    AdminProfileComponent,
    UserProfileComponent,
    CustomAlertComponent,
    AgentProfileComponent,
    AgentAccountComponent,
    UserAgentsComponent,
    MatchPasswordDirective,
    ManageAdminComponent,
    PermissionsComponent,
    QuickFundingComponent,
    FilterPipe,
    MoneyFormatterPipe,
    Page500Component,
    Page404Component,
    AirtimeComponent,
    FundRequestsComponent,
    TransactionsPipe,
    TransactionStatusFilterPipe,
    WalletComponent,
    ApproveFunding,
    DeclineFunding,
    ViewProofOfPayment,
    FundHistoryComponent,
    FundRequestFilterPipe,
    WalletTransactionsPipe,
    FundAgentsComponent,
    UserStatusFilterPipe,
    FrozenAccountsComponent,
    detailsDialogComponent,
    NetworkDialogComponent,
    AgentDialogComponent,
    ReportDialogComponent,
    AgentReportDialogComponent,
    WalletReportDialogComponent,
    CustomerProfileComponent,
    AdminAccountComponent,
    NetworksConfigurationComponent,
    FundRequestHistoryFilterPipe,
    LandingPageComponent,
    HomeComponent,
    LandingPageNavbarComponent,
    Logo2Component,
    AgentSignUpComponent,
    AgentDashboardComponent,
    CustomerSignUpComponent,
    AgentSellComponent,
    AgentTransactionHistoryComponent,
    SellAirtimeComponent,
    SelectPackageComponent,
    SellDataComponent,
    AgentNewFundRequestComponent,
    AgentFundRequestHistoryComponent,
    AgentSupportComponent,
    LandingPageFooterComponent,
    CustomerDashboardComponent,
    CustomerHomeComponent,
    CustomerSettingsComponent,
    CustomerTransactionHistoryComponent,
    CommissionAccountsComponent,
    PayoutRequestsComponent,
    CheckNullPipe,
    BuyAirtimeComponent,
    BuyDataComponent,
    PaymentStatusComponent,
    AgentWalletComponent,
    GuestAirtimeComponent,
    GuestDataComponent,
    AgentDataHistoryComponent,
    AgentChangePasswordComponent,
    TransactionDialogComponent,
    AgentWalletReportDialogComponent,
    ReportDialogComponent,
    AgentWalletTransactionHistoryComponent,
    ReportDialogComponent
  ],
  entryComponents: [ DialogResultComponent, ReportDialogComponent, AgentWalletReportDialogComponent, AgentReportDialogComponent, AgentDialogComponent, WalletReportDialogComponent, ReportDialogComponent, NetworkDialogComponent, FreezeAccountComponent, fundDialogComponent, ApproveFunding, DeclineFunding, ViewProofOfPayment, detailsDialogComponent, TransactionDialogComponent],
  providers: [SharedService, ErrorService, AuthService, AnonymousService, UserService, SortingService, ToastService,  MainMenuService, MainMenu, AuthGuard, AgentGuard, AdminGuard, StorageService],
  bootstrap: [ AppComponent ]

})

export class AppModule {

}




// WEBPACK FOOTER //
// ./src/app/app.module.ts